import { useContext } from 'react';
import { useStyletron } from 'baseui';
import { Card } from 'baseui/card';
import { toaster } from 'baseui/toast';
import { projectsproposal } from '@gtintel/platform-api';
import { Button } from '@gtintel/platform-atoms';
import { useAsyncOp } from '@gtintel/platform-utils';
import { Partner } from '../../../ProjectApp/Requests/Steps';
import { RequestEditorContext } from '../../../ProjectApp/context';
import { useMatching } from '../../context';
export function PartnerSelection() {
  const matchCtx = useMatching();
  const requestEditorContext = useContext(RequestEditorContext);
  const [css] = useStyletron();
  const {
    isLoading,
    fn: sendMatch
  } = useAsyncOp(projectsproposal);
  const handleMatch = () => {
    sendMatch({
      project_id: String(matchCtx.matchHintModal.projectId),
      user_id: String(requestEditorContext.partner()?.id)
    }).then(() => {
      matchCtx.setMatchHintModal({
        isVisible: false
      });
      toaster.positive('Match request sent');
    }).catch(error => {
      toaster.negative('Match failed to send' + error);
    });
  };
  return <Card title="Match a Partner">
      <Partner />
      <div className={css({
      display: 'flex',
      paddingTop: '20px'
    })}>
        <Button kind="primary" loading={isLoading} onClick={handleMatch} disabled={!requestEditorContext.partner()}>
          Send Match Request
        </Button>
      </div>
    </Card>;
}
export default PartnerSelection;